import axios from "axios";
import { environment } from "../../environments/environment";
import { omitEmpty } from "../utils/object-utils";

export interface Job {
    id: number,
    jobpostId: number,
    jobTitle: {
        id: any,
        name: string
    },
    city: {
        id: any,
        displayName: string
    },
    company: {
        id: any,
        name: string
    },
    salary: number,
    showSalary: boolean,
    jobType: string,
    jobDescription: string,
    startDate: string,
    createdAt: string,
    updatedAt: string,
    publishDate: string,
    admin: Record<string, any>,
    contactEmail: string,
    contactName: string,
    status: string,
    escola_do_mecanico: Record<string, any>,
    candidates_quantity?: number
};

interface Params {
    offset?: number,
    limit?: number,
    status?: string,
    search?: string,
    id?: number,
    managerId?: number,
    jobType?: string
};

export const listJobs = async (params?: Params): Promise<{
    totalCount: number,
    data: Job[]
}> => {
    let offset = '';
    let first = '';
    let status = '';
    let search = '';
    let id = '';
    let managerId = '';
    let jobType = '';
    let orderBy = '';

    if (params?.offset) {
        offset = `, offset: ${params.offset}`
    };

    if (params?.limit) {
        first = `, first: ${params.limit}`
        // orderBy = `, orderBy: "-salary,created_at"`
    };

    if (params?.status) {
        status = `, status: ${params.status}`
    };

    if (params?.search) {
        search = `, search: "${params.search}"`
    };

    if (params?.id) {
        id = `, id: ${params.id}`
    };

    if (params?.managerId) {
        managerId = `, managerId: "${params.managerId}"`
    };

    if (params?.jobType) {
        jobType = `, jobType: ${params.jobType}`
    };

    // jobType: FULL_TIME,

    const response = await axios.post(`${environment.apiUrl}/graphql`,
        {
          "operationName": "AllJobs",
          "query": `query AllJobs {
                        allJobs(${orderBy}, ${offset} ${first} ${status} ${search} ${managerId} ${id} ${jobType}, orderBy: "publish_date_desc") {
                            edges {
                                node {
                                    id
                                    jobpostId,
                                    company {
                                        id,
                                        name
                                    },
                                    jobTitle {
                                        id
                                        name
                                    }
                                    salary
                                    jobType
                                    status
                                    jobDescription
                                    startDate
                                    updatedAt
                                    publishDate
                                    showSalary
                                    comission
                                    quantity
                                    minimumEducation
                                    minimumExperience
                                    recommendedCourses {
                                        id
                                        name
                                        institution
                                    }
                                    jobSkills {
                                        id
                                        skillType
                                        skill {
                                            id
                                            name
                                            description
                                            categoryName
                                        }
                                    }
                                    jobBenefits {
                                        id
                                        value
                                        timeUnit
                                        description
                                        jobbenefitId
                                        benefitId
                                        benefit {
                                            id
                                            name
                                            simplifiedName
                                            hasValue
                                            hasTimeUnit
                                        }
                                    }
                                }
                            },
                            totalCount
                        }
                    }`,
          "variables": {}
        }, {
          headers: {
            "content-type": "application/json"
          }
        }
    );

    if(response.status !== 200) {
        throw Error('error');
    };

    return {
        data: response.data.data.allJobs.edges.map((x: any) => x.node),
        totalCount: response.data.data.allJobs.totalCount
    };
};

export const createJob = async (data: any): Promise<any> => {
    const cleanedData = omitEmpty(data);
    const response = await axios.post<any>(environment.apiUrl+'/api/jobpost_new/register/', cleanedData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const updateJob = async (id: any, data: any): Promise<any> => {
    const response = await axios.put<any>(environment.apiUrl+'/api/jobpost/'+id+'/', data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const removeJob = async (id: number, data: {reason_id: number}): Promise<any> => {
    const response = await axios.post<any>(environment.apiUrl+'/api/jobpost_new/remove/'+id, data, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+localStorage.getItem('auth_token')
        }
    });

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data;
};

export const listJobTitles = async (): Promise<{
    id: string,
    name: string
}[]> => {
    const response = await axios.post(`${environment.apiUrl}/graphql`,
        {
          "operationName": "AllJobs",
          "query": `query AllJobs {
                        allJobTitles {
                            id
                            name
                        }
                    }`,
          "variables": {}
        }, {
          headers: {
            "content-type": "application/json"
          }
        }
    );

    if(response.status !== 200) {
        throw Error('error');
    };

    return response.data.data.allJobTitles;
};